import { render, staticRenderFns } from "./Recipe_internal.vue?vue&type=template&id=2672c51c&scoped=true&"
import script from "./Recipe_internal.vue?vue&type=script&lang=js&"
export * from "./Recipe_internal.vue?vue&type=script&lang=js&"
import style0 from "./Recipe_internal.vue?vue&type=style&index=0&id=2672c51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672c51c",
  null
  
)

export default component.exports